import { Reveal } from "./Reveal";

export default function SectionHeading({ eyebrow, title, description, align = "left", dark = false, className = "" }) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}>
      {eyebrow && (
        <Reveal>
          <span className="eyebrow">{eyebrow}</span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.12] ${dark ? "text-sand" : "text-forest"}`}>
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.12}>
          <p className={`mt-5 text-base sm:text-lg leading-relaxed font-light ${dark ? "text-sand/70" : "text-coal-muted"}`}>
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}
